import {useEffect} from "react";
import {useLocation} from "react-router";

import {buildViewTypeFromPathname} from "../features/tracking/algolitycs/utils/build_view_type_from_pathname";
import {viewSessionTimeHit} from "../features/tracking/algolitycs/view_session_time_hit";

export const useSessionTracking = () => {
    const {pathname} = useLocation();
    const viewType = buildViewTypeFromPathname(pathname);

    useEffect(() => {
        let startTime = getCurrentTime();

        const sendHit = () => {
            const now = getCurrentTime();

            if (now < startTime) {
                return;
            }

            viewSessionTimeHit(startTime, now, pathname, viewType);
            startTime = now;
        };

        const handleVisibilityChange = () => {
            if (document.hidden) {
                sendHit();
            } else {
                startTime = getCurrentTime();
            }
        };

        const handlePageHide = () => {
            if (!document.hidden) {
                sendHit();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("pagehide", handlePageHide);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("pagehide", handlePageHide);
            sendHit();
        };
    }, [pathname]);
};

function getCurrentTime() {
    return new Date().getTime();
}
import {useEffect} from "react";
import {useLocation} from "react-router";

import {buildViewTypeFromPathname} from "../features/tracking/algolitycs/utils/build_view_type_from_pathname";
import {viewSessionTimeHit} from "../features/tracking/algolitycs/view_session_time_hit";

export const useSessionTracking = () => {
    const {pathname} = useLocation();
    const viewType = buildViewTypeFromPathname(pathname);

    useEffect(() => {
        let startTime = getCurrentTime();

        const sendHit = () => {
            const now = getCurrentTime();

            if (now < startTime) {
                return;
            }

            viewSessionTimeHit(startTime, now, pathname, viewType);
            startTime = now;
        };

        const handleVisibilityChange = () => {
            if (document.hidden) {
                sendHit();
            } else {
                startTime = getCurrentTime();
            }
        };

        const handlePageHide = () => {
            if (!document.hidden) {
                sendHit();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("pagehide", handlePageHide);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("pagehide", handlePageHide);
            sendHit();
        };
    }, [pathname]);
};

function getCurrentTime() {
    return new Date().getTime();
}
